import { AutoMap } from '@automapper/classes';

export class ProcessTechniqueEntity {
    Id?: number;
    @AutoMap()
    ScolaTechnique!: string
    @AutoMap()
    Humidification!: string
    @AutoMap()
    HumidityWork!: string
    @AutoMap()
    Catchment!: string

    MPCAId?: number;
}
